@if (!hasPermission) {
  <div class="flex items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-6 text-sm font-semibold text-red-700">
    <mat-icon class="!text-base text-red-400">lock</mat-icon>
    Permissions Restricted
  </div>
} @else {
  <div class="flex flex-col">
    <div class="mb-3 flex items-center justify-between">
      <h3 class="text-secondary text-sm font-semibold uppercase tracking-wide">{{ title }}</h3>
      @if (!loading) {
        <span class="rounded-full px-2 py-0.5 text-xs font-semibold" [ngClass]="totalItems | countBadge">{{ totalItems }}</span>
      }
    </div>

    @if (loading) {
      <div class="flex justify-center py-6">
        <mat-spinner diameter="28" color="primary" />
      </div>
    }

    @if (error && !loading) {
      <div class="py-4 text-center text-sm text-red-500">{{ error }}</div>
    }

    @if (!loading && !error) {
      @if (items.length === 0) {
        <div class="text-secondary flex flex-col items-center gap-1 rounded-xl border border-dashed py-6 text-center text-sm">
          <mat-icon class="!text-3xl text-gray-300">inbox</mat-icon>
          <span>Your work queue is clear</span>
        </div>
      }

      <div class="flex flex-col gap-1">
        @for (item of items; track item.source_entity_id + item.item_type) {
          @let cfg = getPriorityConfig(item.priority);
          <div
            class="group flex cursor-pointer items-center gap-2.5 overflow-hidden rounded-lg border border-l-4 border-gray-100 bg-white py-2 pl-2.5 pr-2.5 shadow-sm transition-all hover:shadow-md"
            [ngClass]="cfg.borderClass"
            (click)="navigate(item)"
          >
            <!-- Module icon -->
            <div class="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-gray-100 transition-colors group-hover:bg-gray-200">
              <mat-icon class="!text-sm !leading-none text-gray-500">{{ getModuleIcon(item.module) }}</mat-icon>
            </div>

            <!-- Content -->
            <div class="min-w-0 flex-1">
              <!-- Title row -->
              <div class="flex items-baseline gap-1.5">
                <p class="text-default line-clamp-1 text-xs font-semibold leading-snug group-hover:text-primary">
                  {{ item.title }}
                </p>
                @if (item.reference) {
                  <span class="flex-shrink-0 font-mono text-[10px] text-gray-400">{{ item.reference }}</span>
                }
              </div>
              <!-- Meta row -->
              <div class="mt-0.5 flex flex-wrap items-center gap-x-1 gap-y-0 text-[10px] text-gray-400">
                <span>{{ getItemTypeLabel(item.item_type) }}</span>
                @if (item.entity_status) {
                  <span class="text-gray-300">·</span>
                  <span>{{ item.entity_status }}</span>
                }
                @if (item.days_overdue > 0) {
                  <span class="text-gray-300">·</span>
                  <span class="font-semibold text-red-500">{{ item.days_overdue }} d overdue</span>
                } @else if (item.days_left != null && item.days_left >= 0) {
                  <span class="text-gray-300">·</span>
                  <span class="font-medium text-amber-600">{{ item.days_left }} d left</span>
                } @else if (item.due_date) {
                  <span class="text-gray-300">·</span>
                  <span>{{ item.due_date | date: 'mediumDate' }}</span>
                }
              </div>
            </div>

            <!-- Priority badge -->
            <span class="flex-shrink-0 rounded-full px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider" [ngClass]="[cfg.textClass, cfg.bgClass]">{{ cfg.label }}</span>

            <!-- Chevron -->
            <mat-icon class="flex-shrink-0 !text-sm text-gray-300 opacity-0 transition-all group-hover:text-primary group-hover:opacity-100">chevron_right</mat-icon>
          </div>
        }
      </div>
    }
  </div>
}
